import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#1d96cb",
        },
        secondary: {
            main: "#ffff",
        },
        custom: {
            main: "#000000",
        },
    },
});
